import apptracker from '@utils/sensor/apptracker';
import { Space } from 'antd';
import React from 'react';
import { useAtom } from 'jotai';
import FlowCardWrapper from './FlowCardWrapper';
import RemoveWidget from '../flow-widget/RemoveFlow';
import { removeFlowAtom } from '../../atoms';
import { StyledResult } from './styled';

const RemoveWrapper = ({ flowId }) => {
  const [, removeFlow] = useAtom(removeFlowAtom);

  return (
    <Space>
      <RemoveWidget onClick={() => removeFlow(flowId)} />
    </Space>
  );
};

interface FlowErrorBoundaryProps {
  fid: string;
  children: React.ReactNode;
}

interface FlowErrorBoundaryState {
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
}

class FlowErrorBoundary extends React.Component<FlowErrorBoundaryProps, FlowErrorBoundaryState> {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });

    apptracker('error-boundary', { ...this.state });
  }

  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <FlowCardWrapper
          fid={this.props.fid}
          title={'Error'}
          style={{ gridRow: 'span 7' }}
          extra={<RemoveWrapper flowId={this.props.fid} />}
        >
          <StyledResult status="warning" subTitle="Something went wrong." />
        </FlowCardWrapper>
      );
    }
    // Normally, just render children
    return <React.Fragment key="error-boundary">{this.props.children}</React.Fragment>;
  }
}

export default FlowErrorBoundary;
